import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseButton from './BaseButton.vue';
import { PropType } from 'vue';

type ButtonSize = 's' | 'm';


export default /*#__PURE__*/_defineComponent({
  __name: 'LinkToTopButton',
  props: {
  size: {
    type: String as PropType<ButtonSize>,
    default: 'm',
  },
},
  setup(__props) {



const toTop = () => {
  const url = process.env.VUE_APP_TOP_URL;
  location.href = url;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseButton, {
    size: __props.size,
    theme: "secondary",
    onClick: toTop
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createTextVNode("トップへ戻る")
      ])
    ]),
    _: 3
  }, 8, ["size"]))
}
}

})